import React, { useState } from 'react'
import { Collapse, Button } from 'antd'
import { RowTable } from '../../../article/articleView/RowTable'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import AbstractChargesDrawer from './AbstractChargesDrawer'

const { Panel } = Collapse

const ProcessingCharges = ({ abstract, callback }) => {
  const [visible, setVisible] = useState(false)
  const { processPayment } = abstract

  const headerTitle = `Processing Charges ${abstract.paymentDate ? `(${DisplayDate(abstract.paymentDate)})` : ''}`

  return (
    <div style={{ marginTop: '20px' }}>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
        <Panel
          header={headerTitle}
          key="1"
          extra={<Button size="small" type="primary" onClick={() => setVisible(true)}>{processPayment ? 'Edit' : 'Add'}</Button>}
        >
          <div className={'tableBox striped'}>
            <RowTable title={'Date'} value={DisplayDate(abstract.paymentDate)} />
            <RowTable title={'Amount'} value={processPayment ? `${processPayment.paymentType} ${processPayment.processingFee}` : 'N/A'} />
            {/*<RowTable title={'Mode Of Payment'} value={processPayment?.paymentMode || 'N/A'} />*/}
            <RowTable
              title={'Mode Of Payment'}
              value={(processPayment && processPayment.paymentMode) ? processPayment.paymentMode : 'N/A'}
            />
          </div>
        </Panel>
      </Collapse>

      <AbstractChargesDrawer
        visible={visible}
        abstract={abstract}
        onClose={() => setVisible(false)}
        callback={callback}
      />
    </div>
  )
}

export default ProcessingCharges
